import React from "react";
import {
  Button,
  ControlLabel,
  FormControl,
  FormGroup,
  Panel,
  PanelGroup,
  Modal,
  Row,
  Col,
} from "react-bootstrap";
import Switch from "../../shared/Switch";
import Select from "react-select-plus";

const Toggle = ({ on, onChange }) => <Switch onChange={onChange} value={on} />;

const displayToggleWrapperStyle = {
  margin: "5px",
};
const displayToggleLabelStyle = {
  marginLeft: "5px",
};
const displayToggleSwitchStyle = {};
const DisplayToggle = ({ label, on, onChange, onText, offText }) => (
  <div style={displayToggleWrapperStyle}>
    <span style={displayToggleSwitchStyle}>
      <Switch
        onChange={onChange}
        value={on}
        onText={onText}
        offText={offText}
      />
    </span>
    <label style={displayToggleLabelStyle}>{label}</label>
  </div>
);

export default ({
  fields,
  itemTypes,
  totalsRowFields,
  onHide,
  onUpdateField,
  onUpdateTotalsRowField,
  show,
}) => (
  <Modal onHide={onHide} show={show} bsSize="lg">
    <Modal.Header>
      <Modal.Title>Settings</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        <Col xs={6}>
          {Object.keys(fields).map((k) => (
            <Panel key={k}>
              <Panel.Heading>{fields[k].label}</Panel.Heading>
              <Panel.Body>
                {Object.keys(fields[k].fields).map((k2) => (
                  <DisplayToggle
                    key={k2}
                    label={fields[k].fields[k2].label}
                    on={fields[k].fields[k2].visible}
                    onText={fields[k].fields[k2].onText}
                    offText={fields[k].fields[k2].offText}
                    onChange={(visible) =>
                      onUpdateField(`${k}.fields.${k2}`, { visible })
                    }
                  />
                ))}
              </Panel.Body>
            </Panel>
          ))}
        </Col>
        <Col xs={6}>
          <Panel>
            <Panel.Heading>Totals Row</Panel.Heading>
            <Panel.Body>
              <DisplayToggle
                label={totalsRowFields.fields.showTotalsRow.label}
                on={totalsRowFields.fields.showTotalsRow.visible}
                onText={totalsRowFields.fields.showTotalsRow.onText}
                offText={totalsRowFields.fields.showTotalsRow.offText}
                onChange={(visible) =>
                  onUpdateTotalsRowField(`showTotalsRow`, {
                    visible,
                  })
                }
              />
              <Row>
                <Col xs={12}>
                  <Panel>
                    <Panel.Heading>Statistics</Panel.Heading>
                    <Panel.Body>
                      {Object.keys(totalsRowFields.fields.statistics).map(
                        (k) => (
                          <DisplayToggle
                            key={k}
                            label={totalsRowFields.fields.statistics[k].label}
                            on={totalsRowFields.fields.statistics[k].visible}
                            onText={totalsRowFields.fields.statistics[k].onText}
                            offText={
                              totalsRowFields.fields.statistics[k].offText
                            }
                            onChange={(visible) =>
                              onUpdateTotalsRowField(`statistics`, {
                                [k]: {
                                  ...totalsRowFields.fields.statistics[k],
                                  visible,
                                },
                              })
                            }
                          />
                        )
                      )}
                    </Panel.Body>
                  </Panel>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Panel>
                    <Panel.Heading>Included Item Types</Panel.Heading>
                    <Panel.Body>
                      <Select
                        multi
                        value={Object.values(
                          totalsRowFields.fields.includedItemTypes || {}
                        ).map((itemType) => ({
                          value: itemType.id,
                          label: itemType.quantityLabel?.trim()
                            ? `${itemType.name} (${itemType.quantityLabel})`
                            : itemType.name,
                        }))}
                        options={itemTypes.map((itemType) => ({
                          value: itemType.id,
                          label: itemType.quantityLabel?.trim()
                            ? `${itemType.name} (${itemType.quantityLabel})`
                            : itemType.name,
                        }))}
                        clearable={true}
                        searchable={true}
                        onChange={(selectedOptions) => {
                          const newIncludedItemTypes = {};
                          if (selectedOptions && selectedOptions.length > 0) {
                            selectedOptions.forEach((option) => {
                              const itemType = itemTypes.find(
                                (it) => it.id === option.value
                              );
                              if (itemType) {
                                newIncludedItemTypes[itemType.id] = itemType;
                              }
                            });
                          }
                          onUpdateTotalsRowField(
                            `includedItemTypes`,
                            newIncludedItemTypes
                          );
                        }}
                      />
                    </Panel.Body>
                  </Panel>
                </Col>
              </Row>
            </Panel.Body>
          </Panel>
        </Col>
      </Row>
    </Modal.Body>
    <Modal.Footer>
      <Button bsStyle="primary" onClick={onHide}>
        Ok
      </Button>
    </Modal.Footer>
  </Modal>
);
